import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";

export const callCreateCategoryAllGetApi = async () => {
  const { data = [] } = await axiosInstance.get(API.activeCategories);
  return data;
};
